import axios from 'api/axios'
import { Template } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * API call for delete template
 * @param id - id of template to be send to backend for delete template
 * @returns AdminResponse - Response object returned from the server
 */

export const deleteTemplate = async (id: string) => {
	try {
		const { data } = await axios.delete<Template>(`templates/list/${id}`)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default deleteTemplate
